// extracted by mini-css-extract-plugin
export var floatingFooterContainer = "styles-module--floatingFooterContainer--f2781";
export var linksWrapperMob = "styles-module--linksWrapperMob--68da0";
export var mvpConsultWrapper = "styles-module--mvpConsultWrapper--b4ce2";